/*
  Warenkorb (App „UpCart“) – Texte glätten, nur in diesem Theme (30.10.2026), Gestaltung in assets/hn-warenkorb.css
  Die Texte kommen aus den UpCart-Einstellungen und haben dort einen angeklebten Punkt („Warenkorb• 1“,
  „Kasse gehen• €8,99“), „ihren“ statt der Du-Ansprache und den Tippfehler „erhällst“. Sauberer wäre es,
  die Texte direkt in UpCart zu ändern; dann kann diese Datei wieder raus.
*/
(function () {
  var ZIELE = '#CartPopup .upcart-public-header h2, #CartPopup .upcart-checkout-button, #CartPopup .upcart-public-rewards__message p';
  var geplant = false;

  function glaetten(text) {
    return text
      .replace(/\s*•\s*/g, ' · ')
      .replace(/\bum ihren kostenlosen Premium Versand\b/, 'um deinen kostenlosen Premium-Versand')
      .replace(/\berhällst\b/, 'erhältst');
  }

  function anwenden() {
    geplant = false;
    document.querySelectorAll(ZIELE).forEach(function (el) {
      var lauf = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      while (lauf.nextNode()) {
        var alt = lauf.currentNode.nodeValue;
        var neu = glaetten(alt);
        if (neu !== alt) lauf.currentNode.nodeValue = neu;
      }
    });
  }

  // UpCart zeichnet den Warenkorb bei jeder Änderung neu, darum nach jeder Änderung einmal pro Bild prüfen.
  new MutationObserver(function () {
    if (geplant) return;
    geplant = true;
    requestAnimationFrame(anwenden);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  anwenden();
})();
